"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorState = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../../hooks");
/**
 * # 🚨 ErrorState
 *
 * Display an error message. Used by UIs when an exception is caught, and an error message
 * needs to be displayed. If in development mode, the actual error is displayed, otherwise
 * displays a generic message in production mode.
 *
 * ## Usage
 * ```jsx
 * <ErrorState retry={retryCallback} error={Error('Bang!')} />
 * ```
 */
const ErrorState = (props) => {
    const { error, retry } = props;
    const BB = (0, hooks_1.useBlueBase)();
    const ComponentState = (0, hooks_1.useComponent)('ComponentState');
    const development = BB.Configs.getValue('development');
    const csProps = {
        description: development && error
            ? error.message
            : 'An unknown error has occurred. Please try again later.',
        title: development && error ? error.name : 'Error',
    };
    if (retry) {
        csProps.actionTitle = 'Retry';
        csProps.actionOnPress = retry;
    }
    return <ComponentState {...csProps} imageSource="Error"/>;
};
exports.ErrorState = ErrorState;
exports.ErrorState.displayName = 'ErrorState';
